import { createReducer, on } from '@ngrx/store';
import { TreeNode } from 'primeng/api';
import { selectNode, toggleNode, loadCategoriesSuccess, refreshTree } from './CategoryTreeAction';

export interface CategoryTreeState {
    expandedKeys: { [key: string]: boolean };
    selectedKey?: string;
    categories: TreeNode[];
    loading: boolean;
}

export const initialCategoryTreeState: CategoryTreeState = {
    expandedKeys: {},
    selectedKey: undefined,
    categories: [],
    loading: false
};

export const CategoryTreeReducer = createReducer(
    initialCategoryTreeState,
    on(toggleNode, (state, { key, expanded }) => ({
        ...state,
        expandedKeys: { ...state.expandedKeys, [key]: expanded }
    })),
    on(selectNode, (state, { key }) => ({
        ...state,
        selectedKey: key
    })),
    on(loadCategoriesSuccess, (state, { categories }) => ({
        ...state,
        categories,
        loading: false
    })),
    on(refreshTree, (state) => ({
        ...state,
        loading: true
    }))
);
